export default {
  '渠道调拨': '',
  '单据编号': 'Invoice No.',
  '手工单号': 'Manual Ticket',
  '发货单位': 'Deliver Channel',
  '收货单位': 'Receiving Channel',
  '单据日期': 'Date',
  '打印人': 'Who Printed',
  '打印时间': 'Print Time',
  '备注': 'Notes',
  '货号': 'No.',
  '品名': 'Name',
  '颜色编号': 'Color No.',
  '颜色': 'Color',
  '内长': 'Length',
  '数量': 'Quty',
  '吊牌价': 'UNIT Price',
  '吊牌额': 'Tag-Price Amt',
  '发出方签': 'Shipper',
  '日期': 'Date',
  '接收方签': 'Receiver',
  '店长复核': 'Manager Review',
  '店铺编码': 'Channel Code',
  '店铺名称': 'Channel Name',
  '日结日期': 'Day-end Date',
  '销售单情况': 'Sale Receipt Condition',
  '销售金额': 'Sale Amt',
  '计收入': 'count received',
  '销售数量': 'Sale Quty',
  '销售单数': 'Sale Receipt Quty',
  '销售单退货情况': 'Sale Receipt Return Condition',
  '退货金额': 'Return Amt',
  '退货数量': 'Return Quty',
  '退货单数': 'Return Receipt Quty',
  '销售单付款情况': 'Sale Receipt Payment Condition',
  '储值卡充值情况': 'Value Card Pop-up Condition',
  '实收金额': 'Total',
  '赠送金额': 'Gift Amt',
  '充值笔数': 'Pop-up Sum',
  '所有付款方式汇总': 'All Payment Methods Summary',
  '班次': 'Shift',
  '生意额': 'Sales Amt',
  '期初': 'Opening',
  '销售现金': 'Sales Cash',
  '银行存款': 'Bank Deposit',
  '现金调整': 'Cash Adjust',
  '期末': 'End',
  '销售金额（计收入）': 'Sale Amt (count received)',
  '服务费付款情况': 'Service Fee Payments',
  '服务费金额': 'Service Fee Amt',
  '服务费数量': 'Service Fee Quty',
  '服务费单数': 'Service Fee Order Quty',
  '服务费退款情况': 'Service Fee Return',
  '服务费退款': 'Service Fee Return',
  '退款金额': 'Return Amt',
  '退款数量': 'Return Quty',
  '退款单数': 'Return Order Quty',
  '充值金额': 'Top-up Amt',
  '笔': 'No.',
  '合计': 'Total',
  '渠道': 'Channel',
  '收银': 'Sell',
  '销售日期': 'Sale Date',
  '付款方式': 'Payment method',
  '金额': 'Amt',
  '充值单据': 'Top-up Receipt',
  '竖排': 'Vertical',
  '横排': 'Horizontal',
  '颜色/内长': 'Color/Inner Length',
  '尺码': 'size',
  '会员': 'VIP',
  '货品': 'Goods',
  '会员价': 'VIP Price',
  '折扣': 'DCT',
  '折后价': 'NET Price',
  '税额': 'GST Amt',
  '折扣/折后价': 'DCT/NET Price',
  '税额/金额': 'GST Amt/Amt',
  '获得积分': 'Points',
  '储值余额': 'Value Card Balance',
  '积分余额': 'Points balance',
  '充值时间': 'Top-up Time',
  '服务费': 'Service Fee'
}


// WEBPACK FOOTER //
// ./src/i18n/en/receipt.js